module.exports = __webpack_public_path__ + "static/media/WEB-pc_41.abf7d5cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/pc/WEB-pc_41.jpg
// module id = 169
// module chunks = 0